<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Scan Your Property'"
    [canGoBack]="'true'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage"
        />
    }

    @if (loaded) {
      @switch (modalFlow) {
        @case ('firstModal') {
          <tidy-card>
            <tidy-row class="extra-bottom-padding vertical-align-center">
              <tidy-image
                [src]="'assets/svg/videocam.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Scan Interior of Your Property'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'You record a video tour and our AI will analyze it to build a map of your home.'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Just walk around like you are giving a quick tour to a friend, talking about what is shown in the video.'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Then, we will do the rest.'" />
            </tidy-row>
          </tidy-card>
          <tidy-button
            [text]="'Next'"
            [action]="boundSecondModal"
            class="primary" />
          <tidy-button
            [text]="'Skip This'"
            [action]="boundSubmit"
            class="secondary" />
        }
        @case ('recordVideo') {
          <scanner-component (videoUrl)="videoRecorded($event)" />
        }
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
